const DEFAULT_IGNORED_KEYS = new Set([
  "created_by",
  "updated_by",
  "deleted_by",
  "createdat",
  "updatedat",
  "deletedat",
  "created_at",
  "updated_at",
  "deleted_at",
]);

const includesTerm = (
  value: unknown,
  term: string,
  ignoredKeys: Set<string>,
  seen: WeakSet<object>,
): boolean => {
  if (value == null) return false;
  if (typeof value === "string" || typeof value === "number") {
    return String(value).toLowerCase().includes(term);
  }
  if (typeof value === "boolean" || typeof value === "function") return false;
  if (Array.isArray(value)) {
    return value.some((entry) => includesTerm(entry, term, ignoredKeys, seen));
  }
  if (typeof value === "object") {
    if (seen.has(value)) return false;
    seen.add(value);
    return Object.entries(value).some(([key, entry]) => {
      if (ignoredKeys.has(key.toLowerCase())) return false;
      return includesTerm(entry, term, ignoredKeys, seen);
    });
  }
  return false;
};

export const rowMatchesUnifiedSearch = (
  row: unknown,
  searchValue: string,
  extraIgnoredKeys: string[] = [],
): boolean => {
  const term = searchValue.trim().toLowerCase();
  if (term.length < 2) return true;
  const ignoredKeys = new Set(DEFAULT_IGNORED_KEYS);
  extraIgnoredKeys.forEach((key) => ignoredKeys.add(key.toLowerCase()));
  return includesTerm(row, term, ignoredKeys, new WeakSet<object>());
};
